import {get, put} from 'common/utils/http';

const root = 'api/v1/customers/featureFlags/';

export const fetchCustomers = () => get(root);
export const fetchDefaults = () => get(`${root}defaults`);

export const updateCustomersAndGlobal = ({payload}) => put(root, payload);
